import { useStore } from "@nanostores/react";
import clsx from "clsx";
import { useRouter } from "next/navigation";
import { fitTemplateStore, setTypeValues, updateUrl } from "../../_utils/searchStore";

export const Fit = () => {
  const router = useRouter();
  const selectedFit = useStore(fitTemplateStore);

  return (
    <label
      className={clsx(
        "cursor-pointer flex items-center gap-1.5 select-none rounded-[36px] p-1 pr-2.5 transition-colors",
        {
          "bg-fit-4": !selectedFit,
          "bg-fit-3": selectedFit,
        },
      )}
    >
      <div className="relative">
        <input
          type="checkbox"
          className="hidden peer"
          checked={selectedFit}
          onChange={(e) => {
            if (e.target.checked) {
              setTypeValues("isFitTemplate", [
                {
                  type: "isFitTemplate",
                  value: "true",
                },
              ]);
              updateUrl(router);
            } else {
              setTypeValues("isFitTemplate", []);
              updateUrl(router);
            }
          }}
        />
        <div className="w-10 h-6 bg-[#B4CFDB] peer-checked:bg-fit-1 rounded-[36px] transition-colors" />
        <div className="absolute w-5 h-5 rounded-full left-0.5 top-0.5 bg-white peer-checked:translate-x-[16px] transition-transform" />
      </div>
      <p
        className={clsx("text-xs/[14px] font-semibold transition-colors", {
          "text-white": selectedFit,
          "text-fit-3": !selectedFit,
        })}
      >
        Sur-mesure
      </p>
    </label>
  );
};
